import watch from 'redux-watch';
import template from 'promo-header-primary-banner.j2';

import { generate } from '../../../core/js/utils/componentUtils';
import { setupFixedHeader } from '../../../core/js/utils/headerUtils';

/**
 * UW-11993 Needed to remove fixed header class that was added in header
 * component because primaryHeader has not rendered yet
 */
function afterRender() {
    setupFixedHeader()
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-header-promo',
        watch: ['core.primaryHeaderPromo', 'core.siteSwitchingActive'],
        name: 'primaryHeaderPromoComponent',
        template: template,
        afterRender: afterRender
    };
    return generate(config, store, overrides);
}
